import { render } from "./SvgDamage.vue?vue&type=template&id=488f005c&ts=true"
import script from "./SvgDamage.vue?vue&type=script&lang=ts"
export * from "./SvgDamage.vue?vue&type=script&lang=ts"

import "./SvgDamage.vue?vue&type=style&index=0&id=488f005c&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__